<template>
<!--  No poner style a #app, es sobreescrito al abrir un full page modal-->
  <div id="app">
    <div class="d-flex">
      <div id="menu-1" class="app-block z-1">
        <component :is="menu1" :as-wide-screen-menu="true" @switch-menu="[menu1, menu2] = [menu2, menu1]"></component>
        <div class="z-1 mr-2 mt-2 float-right pb-2 d-flex flex-align-center"
             style="position: sticky; bottom: 0; right: 0; gap: 12px">
          <div class="border bd-k10blue border-radius-20 border-size-2 bg-k10red text-center fg-white py-1 px-5 c-pointer"
               v-if="!isNative" @click="toStore()">
            <i class="fa-solid fa-mobile mr-2"></i><span class="text-secondary text-bold">Descarga la aplicación</span>
          </div>
          <button @click="logout()"
                  class="action-button bg-red fg-white p-1 d-flex flex-justify-center flex-align-center"
                  v-if="isLoggedIn">
            <i class="fa-solid fa-right-from-bracket fa-2x"></i>
          </button>
        </div>
      </div>
      <!--    No repetir nunca este id-->
      <div :style="compStyle" id="app-content" class="app-block d-flex flex-column" ref="appContent">
        <div id="sticky-content" class="z-2" ref="stickyContent">
          <span class="badge inside bg-red fg-white z-3" v-if="$store.state.server !== 'PRODUCTION'"
                style="margin-top: var(--safe-area-inset-top)">{{ $store.state.server }}</span>
          <div class="w-100 z-3" :style="topInsetStyle" v-if="showTopInset"></div>
          <transition-group name="slide-from-top" tag="div">
            <nav-bar key="navBar" v-if="!hideNavBar && !hideBecauseScroll" class="z-2"></nav-bar>
            <router-view name="navBarBusqueda" key="navBarBusqueda" v-if="!hideBecauseScroll" class="z-2"></router-view>
            <div key="adsBanner" v-if="routeShowsSpotBanner" class="z-1">
              <!--            Muy importante que el componente ads esté dentro de este div, porque el root node de ads no existe si
                              currentAd tampoco, y esto causa problemas con transition group-->
              <ads></ads>
            </div>
          </transition-group>
        </div>
        <div class="z-1" style="flex: 1 0 auto">
          <div class="d-flex flex-justify-center bg-white" v-if="isReloading">
            <div data-role="activity" data-type="simple" class="mt-20" data-style="color"></div>
          </div>
          <div @touchstart="onTouchStart" @touchmove="onSwipeDown" ref="scrollableContainer" class="h-100">
            <Transition name="slide-fade">
              <router-view :key="`routerView${appVueKey}`" class="h-100"></router-view>
            </Transition>
          </div>
        </div>
        <transition name="slide-from-bottom">
          <bottom-navigation key="bottom-navigation" v-if="showNavigation && !hideBecauseScroll" class="z-2">
          </bottom-navigation>
        </transition>
      </div>
      <component :is="menu2" id="menu-2" class="app-block z-1" :as-wide-screen-menu="true"></component>
    </div>
    <div class="pos-fixed pos-bottom-center w-100 z-2"
         style="height: var(--safe-area-inset-bottom); background-color: #FFFFFF80"></div>
  </div>
</template>

<script>
import {Device} from '@capacitor/device'
import {App} from '@capacitor/app'
import {AppUpdate, AppUpdateAvailability} from '@capawesome/capacitor-app-update'
import { PushNotifications } from '@capacitor/push-notifications'
import { Capacitor } from '@capacitor/core'
import { SplashScreen } from '@capacitor/splash-screen'
import { Network } from '@capacitor/network'
import { SafeArea } from '@capacitor-community/safe-area'
import { Keyboard } from '@capacitor/keyboard'
import { debounce } from "@/utils/debounce"
import { throttle } from "@/utils/throttle"
import normalizeUrl from 'normalize-url'
import {OpenUrl} from "@/mixins/OpenUrl"

import navBar from "@/components/NavBar.vue"
import bottomNavigation from "@/components/bottom-navigation"
import ads from "@/components/ads.vue"
import menuVsc from "@/components/menu-vsc.vue"
import koinonia10Index from "@/views/koinonia10/index.vue"

const platform = Capacitor.getPlatform()

export default {
  name: 'app',
  data() {
    return {
      startY: null,
      startTime: 0,
      isReloading: false, // Bandera para evitar múltiples recargas

      token_notificacion: '',
      processingNetworkListener: false,

      stickyContentSizeObserver: null,

      menu1: 'menuVsc',
      menu2: 'koinonia10Index',
      isNative: Capacitor.isNativePlatform()
    }
  },
  mixins: [OpenUrl],
  components: {
    menuVsc,
    koinonia10Index,
    navBar,
    bottomNavigation,
    ads
  },
  created() {
    this.throttledScrollChecker = throttle(async () => {
      if (!this.ignoreScrollEvents) {
        const scrollY = this.$refs.appContent.scrollTop
        if (this.routeShowsSpotBanner) {
          await this.$store.dispatch('hideWithScroll',scrollY > this.lastKnownScrollPosition)
          this.$store.commit('SET_LAST_KNOWN_SCROLL_POSITION',scrollY)
        }
        if (this.documentBottomCheck) {
          this.$store.commit(
              'SET_AT_DOCUMENT_BOTTOM',
              scrollY + window.innerHeight > this.$refs.appContent.scrollHeight - 200
          )
        }
      }
    }, 200) //Podrían ser 100, 300.. ¯\_(ツ)_/¯
    this.debouncedResizeCallback = debounce((entries) => {
      this.$store.commit('SET_STICKY_CONTENT_HEIGHT', entries[0].borderBoxSize[0].blockSize)
      this.$store.commit('SET_APP_CONTENT_WIDTH', entries[0].borderBoxSize[0].inlineSize)
    }, 100)

    //Escuchar el evento modal-closed emitido por la interfaz de eventos de $FModal
    this.$FModal.eventInterface.$on('modal-closed', this.fpmClosed)
  },
  beforeDestroy() {
    this.$FModal.eventInterface.$off('modal-closed', this.fpmClosed)
  },
  computed: {
    isLoggedIn() {
      return this.$store.getters.isLoggedIn
    },
    showNotification: function () {
      return this.$store.state.notification
    },
    notificaciones_activas: function () {
      return this.$store.state.notificaciones_activas
    },
    notificacionesFirebase: function () {
      return this.$store.getters.notificacionesFirebase
    },
    appVueKey: function() {
      return this.$store.getters.appVueKey
    },
    compStyle() {
      const styles = {'height': 'calc(var(--vh) * 100)', 'overflow': 'scroll'}
      if (!this.showNavigation || this.hideBecauseScroll) {
        styles['padding-bottom'] = 'var(--safe-area-inset-bottom)'
      }
      if (this.$route.name === 'menu_principal' && this.$store.getters.backgroundImage) {
        styles['background-image'] = `url(${this.$store.getters.backgroundImage})`
        styles['background-size'] = 'cover'
        styles['background-position'] = 'center'
        styles['background-attachment'] = 'scroll'
      }
      return styles
    },
    showSideNav() {
      return this.$store.getters.showSideNav
    },
    documentBottomCheck() {
      return this.$store.getters.documentBottomCheck
    },
    routeShowsSpotBanner() {
      return this.$route.matched.some(record => record.meta.spotBanner)
    },
    hideNavBar() {
      return this.$route.matched.some(record => record.meta.hideNavBar)
    },
    showNavigation() {
      return this.$route.matched.some(record => record.meta.showNavigation)
    },
    listenToScroll() {
      return this.routeShowsSpotBanner || this.documentBottomCheck
    },
    lastKnownScrollPosition() {
      return this.$store.getters.lastKnownScrollPosition
    },
    ignoreScrollEvents() {
      return this.$store.getters.ignoreScrollEvents
    },
    hideBecauseScroll() {
      return this.$store.getters.hideBecauseScroll
    },
    topInsetStyle() {
      return {
        'background': `linear-gradient(to right, ${this.$store.getters.navColor1}, ${this.$store.getters.navColor2})`,
        height: 'var(--safe-area-inset-top)',
      }
    },
    showTopInset() {
      return this.$store.getters.showTopInset
    },
    fullscreenComponent() {
      return this.$store.getters.fullscreenComponent
    },
    fullModalPositions() {
      return this.$store.getters.fullModalPositions
    },
    eventBus() {
      return this.$store.getters.eventBus
    }
  },
  watch: {
    async isLoggedIn(newValue) {
      if (newValue && this.isNative) {
        if (this.notificacionesFirebase) {
          //Ya se ha realizado una configuración en la cuenta y se tiene un token registrado, verificar este registro
          // con el nuevo usuario
          this.enviar_datos_notificacion()
        }
        else {
          //No se ha realizado la configuración de listeners ni mostrado el prompt, hacerlo
          await this.addNotificationsListeners()
          await this.registerNotifications()

          // Esperar un segundo y ver si el token ya se registró, si no, hacerlo
          setTimeout(() => {
            if (this.token_notificacion.length === 0){
              console.log('No se registró automáticamente en Firebase, hacerlo')
              PushNotifications.register()
            }
          }, 1000)
        }
      }
    },
    showNotification(notification) {
      if (notification) {
        Metro.infobox.create("<p>" + notification.content + "</p>", notification.type);
      }
    },
    showSideNav(newValue) {
      if (newValue) {
        $("#app-content").css("overflow", "hidden")
      } else {
        $("#app-content").css("overflow", "scroll")
      }
    },
    listenToScroll(newValue) {
      if (newValue) {
        this.$refs.appContent.addEventListener("scroll", this.throttledScrollChecker)
      } else {
        this.$refs.appContent.removeEventListener("scroll", this.throttledScrollChecker)
      }
    },
    routeShowsSpotBanner(newValue) {
      if (!newValue) {
        this.$store.commit('SET_HIDE_BECAUSE_SCROLL', false)
      }
    },
    eventBus(newValue) {
      if (newValue && newValue.type === 'scroll-to') {
        const options = {...newValue.data}
        if (options.toBottom) {
          options.top = this.$refs.appContent.scrollHeight
        }
        this.$refs.appContent.scrollTo(options)
      }
    }
  },
  async mounted () {
    if (this.isNative) {
      this.validaUpdate()
    }

    // En caso de que alguna vez se olvide:
    // Establecer las opciones de configuración "splashFullScreen" y/o "splashImmersive" de @capacitor/splash-screen
    // como true interfiere con el funcionamiento de @capacitor-community/safe-area (probado en Android 11, la
    // aplicación deja de funcionar como Edge To Edge)
    await SplashScreen.hide()

    const info = await Device.getInfo()

    await SafeArea.setSystemBarsStyle({
      style: platform === 'android' && info.androidSDKVersion <= 28 ? 'DEFAULT' : 'LIGHT',
      type: null
    })

    //Listener del estado de conexión conexión
    await Network.addListener('networkStatusChange', async status => {
      if (!this.processingNetworkListener) {
        this.processingNetworkListener = true
        if (status.connected) {
          if (this.$route.name === 'inactive-connection') {
            Metro.toast.create("Conexión reestablecida", null, 5000, "success")
            if (!this.isLoggedIn) {
              await this.$store.dispatch('tryAutoLogin')
            }
            if (this.$route.name !== 'menu_principal') {
              await this.$router.back()
            }
          }
        } else {
          Metro.toast.create("Sin conexión a internet", null, 5000, "alert")
        }
        setTimeout(() => {
          this.processingNetworkListener = false
        }, 250)
      }
    })

    if (this.isNative) {
      //Los listeners keyboardDidShow y keyboardWillShow no funcionan en SKD 28 (Android 9), pero sí en SDK 30 (Android 11)
      //Se necesita reproducción del bug en otros dispositivos/emuladores y ver a partir de cual SDK funcionan
      Keyboard.addListener('keyboardDidShow', info => {
        const element = document.activeElement
        if (element) {
          if (element.classList.contains('autocomplete-input')) {
            const container = element.closest('.autocomplete-container')
            container.scrollIntoView({
              behavior: "smooth",
              block: "start"
            })
          } else if (platform === 'ios') {
            element.scrollIntoView({
              behavior: "smooth",
              block: "center"
            })
          }
        }
      })
    }

    this.token_notificacion = localStorage.getItem('fcmToken') || ''
    this.$store.commit('SET_NOTIFICACIONES_FIREBASE', this.token_notificacion.length > 0)

    if (this.isNative) {
      if (platform === 'android' && info.androidSDKVersion >= 26) {
        console.log('plataforma android, SDK:',info.androidSDKVersion)
        await PushNotifications.createChannel({
          id: "1",
          name: "Todas",
          description: "Todas las notificaciones",
          visibility: 0,
          lights: true,
          lightColor: "#FF5F1F",
          vibration: true
        })
      }
      if (!this.notificacionesFirebase && this.isLoggedIn) {
        console.log('Montando APP, loggeado y sin notificaciones de Firebase')
        this.token_notificacion = '' //Quitar el token de OneSignal que pudiese estar registrado
        await this.addNotificationsListeners()
        await this.registerNotifications()

        // Esperar un segundo y ver si el token ya se registró, si no, hacerlo
        setTimeout(() => {
          if (this.token_notificacion.length === 0){
            console.log('No se registró automáticamente en Firebase, hacerlo')
            PushNotifications.register()
          }
        }, 1000)
      }
    }

    App.addListener('backButton', (event) => {
      if (this.fullModalPositions.length) {
        this.$FModal.hide()
      } else if (this.showSideNav) {
        this.$store.commit('SET_SHOW_SIDE_NAV', false)
      } else if (this.fullscreenComponent) {
        this.$store.commit('SET_FULLSCREEN_COMPONENT', false)
      } else if (this.$store.state.path_back) {
        this.$router.push({path: this.$store.state.path_back})
      } else if (event.canGoBack) {
        this.$router.back()
      } else if (platform === 'android') {
        App.exitApp()
      }
    })

    //Listener para deep links
    await App.addListener('appUrlOpen', event => {
      const domain = normalizeUrl(
          event.url, {stripWWW: false, stripHash: true, removeQueryParameters: true, removePath: true}
      )
      const path = event.url.replace(domain, '')
      if (path.startsWith('/') && this.$route.path !== path) {
        this.$router.push({path: path})
      } else {
        this.$FModal.destroyAll()
        this.$store.commit('SET_FULL_MODAL_POSITIONS', [])
      }
      this.$swal.close()
    })

    //Listener para cambio de estado de la app (entra o sale del primer plano)
    await App.addListener('appStateChange', ({ isActive }) => {
      if (!isActive && !this.isLoggedIn) {
        this.$store.dispatch('sendShowedAds')
        this.$store.dispatch('sendShowedIntermedios', true)
      }
    })

    //Inicializar observer del tamaño de sticky content
    this.stickyContentSizeObserver = new ResizeObserver((entries) => {
      this.debouncedResizeCallback(entries)
    })
    this.stickyContentSizeObserver.observe(this.$refs.stickyContent, {box: 'border-box'})

    //Configuración predeterminada para Metro.notify
    Metro.notify.setup({
      width: 300,
      duration: 1000,
      animation: 'easeOutBounce'
    })
  },
  methods: {
    validaUpdate: async function () {
      const result = await AppUpdate.getAppUpdateInfo().catch((error) => console.log(error))
      console.log('AppUpdateInfo: ',result)
      if (result && result.updateAvailability === AppUpdateAvailability.UPDATE_AVAILABLE) {
        await this.$router.push({path: '/new-version'})
      }
    },
    addNotificationsListeners: async function(){
      await PushNotifications.addListener('registration', token => {
        console.info('Registration token received: ', token.value)
        if (this.token_notificacion.length === 0) {
          this.token_notificacion = token.value
          console.log('Por registrar token en base de datos')
          this.enviar_datos_notificacion()
        }
      })

      await PushNotifications.addListener('registrationError', err => {
        console.error('Registration error: ', err.error)
      })

      await PushNotifications.addListener('pushNotificationReceived', notification => {
        console.log('Push notification received: ', notification)
      })

      await PushNotifications.addListener('pushNotificationActionPerformed', notification => {
        console.log('Push notification action performed', notification.actionId, notification.inputValue)
        if (notification.notification.data.url) {
          this.$router.push({path: notification.notification.data.url})
        }
      })
    },
    registerNotifications: async function() {
      let permStatus = await PushNotifications.checkPermissions()
      console.log('Permisos checados: ', permStatus.receive)

      if (permStatus.receive === 'prompt') {
        permStatus = await PushNotifications.requestPermissions()
        console.log('Permisos solicitados: ', permStatus.receive)
      }
    },
    onTouchStart(event) {
      this.startY = event.touches[0].clientY
      this.startTime = Date.now()
    },
    onSwipeDown(event) {
      if (this.startY !== null) {
        const deltaY = event.touches[0].clientY - this.startY;
        const scrollTop = this.$refs.scrollableContainer.scrollTop;
        const currentTime = Date.now();
        const timeElapsed = currentTime - this.startTime;

        // Verifica que el desplazamiento sea hacia abajo y que sea mayor que cierta cantidad (por ejemplo, 50 píxeles)
        if (scrollTop === 0 && deltaY > 350 && (deltaY / timeElapsed > 0.9) && !this.isReloading) {
          this.reloadAPP();
          this.startY = null; // Restablece el valor de startY
        }
      }
    },
    async reloadAPP() {
      this.isReloading = true
      await this.$store.dispatch('refreshState')

      setTimeout(() => {
        this.updateKey()
        this.isReloading = false
      }, 500)
    },
    updateKey: function () {
      this.$store.commit('SET_APP_VUE_KEY', (Math.random().toString(36) + '00000000000000000').slice(2, 20))
    },
    enviar_datos_notificacion: async function () {
      const info = await Device.getInfo();
      this.axios.post('api/notificacion/user.json', {
        token_notificacion: this.token_notificacion,
        manufacturer: info.manufacturer,
        model: info.model,
        platform: info.platform
      }).then((response) => {
        if (response.data.status === 'success') {
          this.$store.commit('SET_NOTIFICACIONES_ACTIVAS', true)
          this.$store.commit('SET_NOTIFICACIONES_FIREBASE', true)
          localStorage.setItem('fcmToken',this.token_notificacion)
          Metro.toast.create("Ahora recibes notificaciones en este dispositivo", null, 5000, "success")
        }
      }).catch(function (error) {
        console.log(error)
      })
    },
    async fpmClosed() {
      if (this.fullModalPositions.length > 1) {
        await new Promise(resolve => {
          setTimeout(() => {
            window.scrollTo({
              top: this.fullModalPositions.slice(-1)[0],
              left: 0,
              behavior: "instant"
            })
            resolve()
          }, 200)
        })
      }
      this.$store.commit('POP_FROM_FULL_MODAL_POSITIONS')
    },
    async logout() {
      if (this.$route.name !== 'menu_principal') {
        await this.$router.push({name: 'menu_principal'})
      }
      await this.$store.dispatch("logout")
    },
    toStore() {
      this.open_url(`${process.env.VUE_APP_URL}redirect-to-store`)
    }
  }
}
</script>

<style scoped>
#sticky-content {
  top: 0;
  position: sticky;
}
.app-block {
  width: 100%;
}
#menu-1, #menu-2 {
  display: none;
  height: calc(var(--vh) * 100);
  overflow: scroll;
  padding-bottom: var(--safe-area-inset-bottom);
}
@media (min-width: 824px) {
  #menu-1 {
    display: block;
  }
  .app-block {
    width: 50%;
  }
}
@media (min-width: 1236px) {
  .app-block {
    width: calc(100% / 3);
  }
  #menu-2 {
    display: block;
  }
}
</style>

<style>
/*Font faces (deben estar aquí porque los archivos de fuentes se encuentran dentro de @/assets)*/
@font-face {
  font-family: "Open Sans";
  src: local("Open Sans Regular"), local("OpenSans"), url("@/assets/fonts/OpenSans-Regular-webfont.woff") format('woff');
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "Open Sans Bold";
  src: local("Open Sans Bold"), local("OpenSans-Bold"), url("@/assets/fonts/OpenSans-Bold-webfont.woff") format('woff');
  font-weight: normal;
  font-style: normal;
}
/*Reemplazo de Helvetica*/
@font-face {
  font-family: "Helvetica";
  src: local('Nimbus Sans Regular'), local('Nimbus-Sans-Regular'),
    url("@/assets/fonts/NimbusSanL-Reg.woff2") format('woff2'),
    url('@/assets/fonts/NimbusSanL-Reg.woff') format('woff');
  font-weight: normal;
  font-style: normal;
}
</style>